<template>
  <div class="device-info-management">
    <el-card shadow="never" class="animate__animated animate__fadeInUp">
      <div class="filter-card">
        <div class="filter-bar">
          <div class="filter-group">
            <el-input v-model="searchUserId" placeholder="用户ID" clearable class="filter-input-id" @keyup.enter.native="handleSearch" />
            <el-input v-model="searchDeviceId" placeholder="设备ID" clearable class="filter-input" @keyup.enter.native="handleSearch" />
            <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="refreshList">刷新</el-button>
          </div>
        </div>
      </div>

      <el-table :data="list" border stripe v-loading="loading" row-key="id">
        <el-table-column prop="id" label="ID" width="80" align="center" />
        <el-table-column prop="userId" label="用户ID" width="90" align="center" />
        <el-table-column prop="deviceId" label="设备ID" min-width="200" show-overflow-tooltip />
        <el-table-column prop="lastIp" label="最后IP" width="140" show-overflow-tooltip />
        <el-table-column prop="lastTime" label="最后活跃" width="170" align="center" />
      </el-table>

      <div v-if="pagination.total > 0" class="pagination-container">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next"
          :current-page="pagination.page"
          :page-size="pagination.pageSize"
          :page-sizes="[10, 20, 50]"
          :total="pagination.total"
          @current-change="handlePageChange"
          @size-change="handleSizeChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import { get } from '@/utils/http'

export default {
  name: 'DeviceInfoManagement',
  data() {
    return {
      list: [],
      loading: false,
      searchUserId: '',
      searchDeviceId: '',
      pagination: { page: 1, pageSize: 10, total: 0 }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    async fetchList() {
      this.loading = true
      try {
        const params = { page: this.pagination.page, pageSize: this.pagination.pageSize }
        if (this.searchUserId) params.userId = this.searchUserId
        if (this.searchDeviceId) params.deviceId = this.searchDeviceId
        const result = await get('/admin/device/list', params)
        const data = result.data || {}
        this.list = Array.isArray(data.records) ? data.records : []
        this.pagination.total = data.total || 0
      } catch (e) {
        this.$message.error(e.message || '加载失败')
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.pagination.page = 1
      this.fetchList()
    },
    refreshList() {
      this.searchUserId = ''
      this.searchDeviceId = ''
      this.pagination.page = 1
      this.fetchList()
    },
    handlePageChange(page) {
      this.pagination.page = page
      this.fetchList()
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.page = 1
      this.fetchList()
    }
  }
}
</script>

<style scoped>
.pagination-container { margin-top: 16px; text-align: right; }
</style>
